import TooltipModal from 'components/Header/BeautyPreferences/TooltipModal/TooltipModal';
import { withTooltipModalProps } from 'viewModel/header/beautyPreferences/tooltipModal/withTooltipModalProps';

const ConnectedTooltipModal = withTooltipModalProps(TooltipModal);

export default ConnectedTooltipModal;
